module.exports = __webpack_public_path__ + "img/10.bf46422d.jpg";